import { defineStore } from 'pinia'
import Actions from './actions'
import { useState } from './state'

export { type CatalogState } from './state'

export const useCatalogStore = defineStore('catalog', {
  state: useState,
  actions: { ...Actions },
})

export type CatalogStoreContext = ReturnType<typeof useCatalogStore>